import {connect} from 'react-redux'
import withRouter from "../../../components/RouterComponentWrapper";
import StatistikGameView from "../../../components/views/public/tournaments/StatistikGameView";

const mapStateToProps = function (state, ownProps) {
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const gameId = urlParams.get('gameid');
    return {gameId: gameId};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StatistikGameView))